import React from "react";
import { Stack } from "@mui/material";
import FrameCard from "../../shared/FrameCard";
import SectionTitle from "../../shared/SectionTitle";
import QualificationList from "./QualificationList";
import ExpandableSection from "../ExpandableSection";

const INITIAL_COUNT = 6;

/**
 * 資格セクション
 *
 * - 初期は6つのみ表示
 * - 6個未満の場合は ExpandableSection を表示しない
 */
const QualificationSection = ({ qualifications = [] }) => {
  const isExpandable = qualifications.length > INITIAL_COUNT;
  const visibleItems = qualifications.slice(0, INITIAL_COUNT);
  const hiddenItems = qualifications.slice(INITIAL_COUNT);

  return (
    <FrameCard>
      <Stack spacing={2}>
        <SectionTitle title="資格" />

        {isExpandable ? (
          <ExpandableSection
            summaryText="もっと見る"
            collapsedContent={
              <QualificationList qualifications={visibleItems} />
            }
            expandedContent={<QualificationList qualifications={hiddenItems} />}
          />
        ) : (
          <QualificationList qualifications={qualifications} />
        )}
      </Stack>
    </FrameCard>
  );
};

export default QualificationSection;
